import Shuffle from 'shufflejs';
import 'whatwg-fetch';
import $ from 'jquery';


$( document ).ready( function() {
  var currentPage = 1;
  var articleData;
  var articleLength;
  var totalPages;
  var items;
  var queryArgs;
  var excludeIds
  var fetchPage = function( queryArgs ) {
    var url;
    if( queryArgs ) {
      url = `/wp-json/wp/v2/posts/?page=${currentPage}&${queryArgs}&orderby=meta_value&meta_key=date_published`;
   } else {
     url = `/wp-json/wp/v2/posts/?page=${currentPage}&orderby=meta_value&meta_key=date_published`;
   }
    fetch( url )
      .then(function (response) {
        if (response.status === 400 ) {
          // document.querySelector('#press-button').classList.add( 'alm-load-more-btn', 'done' );
          $( '#press-button' ).addClass( 'display--none' );
          throw new Error( 'No more articles to pull' );
        }
        currentPage++;
        return response.json();
      })
      .then(function (response) {
        totalPages = response.total_pages;
        articleData = response;
        
        
        articleLength = articleData.length;
        articleData.forEach(
          function(article) {
            let date1 = new Date();
            let articleDate;
            let articleCategory;
            let articleSource;
            if ( article['acf']['date_published'] ) {
              articleDate = new Date( article['acf']['date_published'] );
            } else {
              articleDate = new Date( article['date'] );
            }
            date1 = ( date1.getFullYear() - 1 );
            let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            let postDate = `${months[ articleDate.getMonth() ]} ${articleDate.getDate()}, ${articleDate.getFullYear()}`;
            articleDate = articleDate.getFullYear();
            if( articleDate <= date1 ) {
              articleCategory = 'archive';
            } else {
              articleCategory = article['acf']['press_category'];
            }
            if( article['acf']['news_source'] && postDate ) {
              articleSource = article['acf']['news_source'] + ':';
            } else {
              articleSource = article['acf']['news_source'];
            }
            items = `<div class="card--related cell card grid-y p-x-2 p-y-1 m-b-1 shuffle shuffle-item ${articleCategory}" data-groups='["${articleCategory}"]'>
            <div class="card__news text--dark-gray font-size--14">${articleSource} <span class="card-time">${postDate}</span> </div>
            <div class="card__title card__title font--opensans-bold text--dark-gray font-size--18--medium font-size--16">${article['title']['rendered']}</div>
            <a class="card__read-more font--opensans-bold p-t-1" target="_blank" href="${article['acf']['read_more_link']}">READ MORE</a>
            </div>`;
            newItems.push(items);
            $('#press-grid').append(items);
          }
        );
        myShuffle = new Shuffle( pressGrid, {
          itemSelector: '.card--related',
          sizer:  '.card--related'
          // itemSelector: '.grid-item--press'
        } );
        myShuffle.layout();
      })
  }

  var dateFilt = function() {
    let dateFilter;
    dateFilter = new Date();
    dateFilter.setFullYear( dateFilter.getFullYear() - 1 );
    dateFilter = dateFilter.toISOString();
    return dateFilter;
  };

  var catLength = function( category, queryArgs ) {
    if( $( `.${category}` ).length < 6 ) {
      fetchPage(queryArgs);
      myShuffle.filter( category );
    }
  }

  var pressButton = $( '#press-button' );
  var pressGrid = document.querySelector( '#press-grid' );
  var ajax = document.querySelector( '.alm-reveal' );
  var newItems = [];
  if( pressGrid ) {
    var shuffleTown = window.Shuffle;
    var myShuffle;
    var filterBox = document.querySelector( '.filter-box' );
    Array.from(filterBox.children).forEach((child, index) => {
      let childData = child.dataset.query;
      if( childData === "archives" ) {
        let dateFilter = dateFilt();
        child.dataset.query = `before=${dateFilter}`;
      }
      child.addEventListener( "click", function() {
        let category = this.dataset.cat;
        currentPage = 1;
        pressGrid.innerHTML = '';
        queryArgs = this.dataset.query;
        if( $( '#press-button.display--none' ) ) {
          $( '#press-button' ).removeClass( 'display--none' );
        }

        if( category === 'reset' ) {

          $( '.filter-box__select--current' ).removeClass('filter-box__select--current');
          $( this ).addClass('filter-box__select--current');

          catLength( category, queryArgs );

          myShuffle.filter();
        } else {

          $( '.filter-box__select--current' ).removeClass('filter-box__select--current');
          $( this ).addClass('filter-box__select--current');

          catLength( category, queryArgs );

          myShuffle.filter( category );
        }
      });

    } );


    var currentSite = window.location.hostname;
    pressButton.on( 'click', function() {

      queryArgs = document.querySelector('.filter-box__select--current').dataset.query;
      fetchPage(queryArgs);

    } );

    fetchPage(queryArgs);
  }
} );
